import { default as index5dPSvTBjuQMeta } from "/var/www/canceller/pages/index.vue?macro=true";
import { default as privacy_45policysItDwwNUP4Meta } from "/var/www/canceller/pages/privacy-policy.vue?macro=true";
import { default as terms_45of_45serviceGW2suKt0HWMeta } from "/var/www/canceller/pages/terms-of-service.vue?macro=true";
import { default as verify_45emailX1TzMqIQgbMeta } from "/var/www/canceller/pages/verify-email.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/canceller/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/canceller/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    component: () => import("/var/www/canceller/pages/terms-of-service.vue").then(m => m.default || m)
  },
  {
    name: "verify-email",
    path: "/verify-email",
    component: () => import("/var/www/canceller/pages/verify-email.vue").then(m => m.default || m)
  }
]